module.exports = __webpack_public_path__ + "static/media/_MIC2795.thumbnail.0255dc90.png";